export default __webpack_public_path__ + "static/media/twitterLogo.f963dcac.png";